import { Cell } from "@antv/x6"
import { useEffect, useState } from "react"

export const useReloadWhenUnitChange = (unit: Cell) => {
  const [change, setChange] = useState({})

  useEffect(() => {
    if (!unit) {
      return
    }
    unit.on('changed', () => {
      setChange({})
    })

  }, [unit])

  return change
}